<template>
    <el-dialog custom-class="dialogForm" class="measDialog" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" title="订单详情">
        <el-scrollbar class="dialogContentScroll">
            <el-form :model="form" ref="form">
                <div class="formItemBox mb-15">
                    <el-form-item label="订单编号" prop="orderno">
                        <el-input v-model="form.orderno" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="订单来源" prop="ordersourcename">
                        <el-input v-model="form.ordersourcename" disabled></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="班级名称" prop="classname">
                        <el-input v-model="form.classname" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="校区名称" prop="campusname">
                        <el-input v-model="form.campusname" disabled></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="学员编号" prop="studentcode">
                        <el-input v-model="form.studentcode" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="学员昵称" prop="nickname">
                        <el-input v-model="form.nickname" disabled></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="学员名称" prop="studentname">
                        <el-input v-model="form.studentname" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="telno">
                        <el-input v-model="form.telno" disabled></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="订单金额" prop="uprice">
                        <el-input v-model="form.uprice" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="支付金额" prop="nowprice">
                        <el-input v-model="form.nowprice" disabled></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="订单状态" prop="statusname">
                        <el-input v-model="form.statusname" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="支付方式" prop="paytypename">
                        <el-input v-model="form.paytypename" disabled></el-input>
                    </el-form-item>
                </div>
                <div class="formItemBox mb-15">
                    <el-form-item label="下单时间" prop="datetime">
                        <el-date-picker v-model="form.datetime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" disabled>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="支付时间" prop="paytime">
                        <el-date-picker v-model="form.paytime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" disabled>
                        </el-date-picker>
                    </el-form-item>
                </div>
            </el-form>
        </el-scrollbar>
        <div slot="footer" style="text-align:right">
            <el-button @click="handleClose">取消</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { getOrderDetail } from '@/api/measApi/transactionManage.js'
export default {
  data() {
    return {
      visible: false,
      form: {
        campuscode: '',
        campusname: '',
        classcode: '',
        classname: '',
        code: '',
        datetime: '',
        nickname: '',
        nowprice: '',
        orderno: '',
        ordersource: '',
        ordersourcename: '',
        paytime: '',
        paytype: '',
        paytypename: '',
        status: '',
        statusname: '',
        studentcode: '',
        studentname: '',
        telno: '',
        uprice: ''
      }
    }
  },
  methods: {
    handleOpen(code) {
      this.visible = true
      getOrderDetail({ code: code }).then(res => {
        if (res.code === '000') {
          this.form = res.data
        }
      })
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>

